import {
  CodeXml,
  Plug,
  Zap,
  CalendarDays,
  Workflow,
  Lightbulb,
} from 'lucide-react';

interface Feature {
  icon: React.ReactNode;
  title: string;
  description: string;
}

export interface FeatureGroupData {
  name: string;
  displayName: string;
  features: Feature[];
}

export interface UseCaseData {
  title: string;
  description: string;
  imageUrl: string;
  templateId: string;
  actionLabel: string;
}

export const onboardingFeatureGroups: FeatureGroupData[] = [
  {
    name: 'create',
    displayName: 'Create & Connect',
    features: [
      {
        icon: <CodeXml />,
        title: 'No-code automation',
        description:
          'Design your workflows in minutes with an intuitive interface. No technical skills required.',
      },
      {
        icon: <Plug />,
        title: '+200 apps',
        description:
          'Connect all your favorite applications in just a few clicks.',
      },
      {
        icon: <Zap />,
        title: 'AI-powered workflow creation',
        description:
          "Simply describe your need in natural language: AI automatically generates the right workflow for you.",
      },
    ],
  },
  {
    name: 'execute',
    displayName: 'Run & Control',
    features: [
      {
        icon: <CalendarDays />,
        title: 'Flexible execution',
        description:
          "Choose how and when your workflows run: in real-time, on-demand, or on a custom schedule.",
      },
      {
        icon: <Workflow />,
        title: 'Workflow monitoring & traceability',
        description:
          "Manage versions and history of your workflows to analyze, restore, and optimize with confidence.",
      },
      {
        icon: <Lightbulb />,
        title: 'Smart error handling',
        description:
          "Anticipate issues with error tracking and automatically triggered fallback flows.",
      },
    ],
  },
];

export const kizeoUseCases: UseCaseData[] = [
  {
    title: 'Real-time notifications',
    description:
      "A technician submits an intervention tracking form, and Khub instantly triggers an alert on Slack or via email to the relevant team.",
    imageUrl: '/img/custom/kizeo/notifications.png',
    templateId: 'kizeo-forms_event_on_data_finished-to-gmail-send_email',
    actionLabel: 'Automate my notifications',
  },
  {
    title: 'CRM updates',
    description:
      'Every time a new customer form is submitted (request, quote, etc.), Khub records the data directly in HubSpot, Salesforce, or Pipedrive—no manual entry required.',
    imageUrl: '/img/custom/kizeo/notifications2.png',
    templateId: 'kizeo-forms_event_on_data_finished-to-hubspot_create-deal',
    actionLabel: 'Update my CRM',
  },
  {
    title: 'Spreadsheet synchronization',
    description:
      'Form responses (e.g., inventory, site reports, audits) are centralized by Khub in Google Sheets, Excel, or Notion to simplify analysis and enable real-time tracking.',
    imageUrl: '/img/custom/kizeo/notifications3.png',
    templateId:
      'kizeo-forms_event_on_data_finished-to-google-sheets_insert_row',
    actionLabel: 'Sync my data',
  },
];
